// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"MapControls_controlsWrapper__XJGeF"};